import { deleteJobRequest as deleteJob } from "../graphql/mutations";
import { API, graphqlOperation } from "aws-amplify";

const deleteJobRequest = async (id) => {
  if (id) {
    //console.log("id", id);
    //const obj = id;
    try {
      const promise = API.graphql(graphqlOperation(deleteJob, { input: id }));
      promise.then(() => {
        return true;
      });
      promise.catch((error) => {
        console.log(error);
        return false;
      });
    } catch (e) {
      return null;
    }
  } else {
    return null;
  }
};

export default deleteJobRequest;
